import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { loginDetails } from '../Home/Login';
import { MultiSelect } from "react-multi-select-component";
import '../../assets/styles/multiple_select.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import { faSearch } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';


const AddNewRoleForm = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [flag, setFlag] = useState(false);
    const [visibility, setVisibility] = useState("");
    const [isActive, setIsActive] = useState("");
    const [schemeData, setSchemeData] = useState([]);
    const [schemeValue, setSchemeValue] = useState("");

    const [userRoleData, setUserRoleData] = useState([]);
    const [userRoleValue, setUserRoleValue] = useState("");
    const [usersData, setUsersData] = useState([])

    const [selected, setSelected] = useState([]);
    let [optionsState, setOptionsState] = useState([]);
    const [formCode, setFormCode] = useState([]);



    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/roleformmapping`);
            setUsersData(result.data.dataContent);
            //getForm()
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (flag == true) {
            fetchData2();
        }
    }, [flag])

    useLayoutEffect(() => {
        // useEffect to set defaultValue in dropdown meun
        if (state) {
            console.log("sate", state)
            getScheme()
            handleUserRole(state.cropSurveyCode.schemeCode)
            setUserRoleValue(state.cropSurveyCode.roleCode)
            setFormCode(state.cropSurveyCode.formCode)
            setUserRoleValue(state.cropSurveyCode.roleCode)
            //setSelected(state.cropSurveyCode.formCode)
            //setUserRoleValue(state.cropSurveyCode.userRoleCode)
            setVisibility(state.cropSurveyCode.isVisible)
            //setIsActive(state.cropSurveyCode.isActive)

        }
    }, [state])




    function getScheme() {
        const fetchScheme = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`);     
            let filterResult = result.data.dataContent.filter(function (el) { return String(el.schemeCode) === localStorage.getItem("schemeCodeSingle")})
            setSchemeData(filterResult);
        };
        fetchScheme();
    }

    function ValidateRoleFormMapping() {
        let valid = false;
         if(schemeValue === "") {
             valid = false;
            alert("Select Correct Scheme")
         }else {
             valid = true
         }
         if(userRoleValue === "") {
             valid = false;
            alert("Select Correct User Role")
         }else {
             valid = true
         }
       
        
         if(valid === true) {
            state ? UpdateRoleForm() : AddNewUserDB()
         }
     
       }

    function AddNewUserDB() {

        let multiSelectValue = "";
        $("input[name='programming']:checked").each(function () {
            multiSelectValue = multiSelectValue + $(this).val() + ","
        });
        multiSelectValue = multiSelectValue.slice(0, -1);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "FormCode": multiSelectValue,
            "SchemeCode": schemeValue,
            "SortingOrder": 1,
            "RoleCode": userRoleValue,
            "IsCreate": 1,
            "IsUpdate": 1,
            "IsDelete": 1
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/roleformmapping`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/roleformmapping")
                }

            })
            .catch(error => console.log('error', error));
    }

    function UpdateRoleForm() {

        let multiSelectValue = "";
        $("input[name='programming']:checked").each(function () {
            multiSelectValue = multiSelectValue + $(this).val() + ","
        });
        multiSelectValue = multiSelectValue.slice(0, -1);

         var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw2 = JSON.stringify({
            "RoleCode": userRoleValue,
            "SchemeCode": schemeValue,
            "FormCode": multiSelectValue,
            "SortingOrder": 1,
            "IsCreate": 1,
            "IsUpdate": 1,
            "IsDelete": 1,
            "Visibility": 1,
            "ModifiedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw2,
            redirect: 'follow'
        };
         fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/roleformmapping`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/roleformmapping")
                }

            })
            .catch(error => console.log('error', error));
    }

    async function fetchData2() {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
        setUsersData(result.data.dataContent);
    }

    function handleUserRole(value) {
        setSchemeValue(value);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SchemeCode": value
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/userrole/GetUserRolebySchemeCode`, requestOptions)
            .then(response => response.text())
            .then(result => {
                setUserRoleData(JSON.parse(result).dataContent)
                console.log("data", JSON.parse(result).dataContent)
            })
            .catch(error => console.log('error', error));

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms/GetForms`, requestOptions)
            .then(response => response.text())
            .then(result => {

                let localFormData = JSON.parse(result).dataContent

                let myArray = [];
              
                localFormData.map((item, key) => {
                    myArray.push({ label: item.formName, value: item.rO_FormCode })
                })
                setOptionsState(myArray)
               
            })
            .catch(error => console.log('error', error));


    }

    function handleChecked(e) {
        formCode.replace(e.target.value, "")
    }

    function handleFilter() {
        var input, filter, div, li, a, i, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        div = document.getElementById("myUL");
        li = div.getElementsByTagName("label");
        for (i = 0; i < li.length; i++) {
            a = li[i].getElementsByTagName("span")[1];
            txtValue = a.textContent || a.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        }
    }


    return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New Role Form</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Add New Role Form</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">

                            <form className="g-3 addNewUser">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label for="Department" className="form-label">Scheme</label>
                                        <select id="scheme" required className="form-select" onClick={getScheme} onChange={(e) => handleUserRole(e.target.value)} value={schemeValue} disabled={state ? true : false}>
                                            <option selected>Choose...</option>
                                            {schemeData.map((item, id) => {
                                                return <option key={id} value={item.schemeCode}> {item.schemeName}</option>
                                            })}

                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label for="userRole" className="form-label">Role</label>
                                        <select id="userRole" required className="form-select" onChange={e => setUserRoleValue(e.target.value)} value={userRoleValue} disabled={ state ? true : false}>
                                            <option selected>Choose...</option>
                                            {userRoleData.map((item, id) => {
                                                return <option key={id} value={item.userRoleCode}> {item.userRoleName}</option>
                                            })}

                                        </select>
                                    </div>

                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label for="scheme" className="form-label">Form</label>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input-group">
                                                    <input type="text" id="myInput" onKeyUp={handleFilter} className="form-control" placeholder="Search Forms" />
                                                    <div className="input-group-append searchBTN">
                                                        <button className="btn btn-default" type="button">
                                                            <i><FontAwesomeIcon icon={faSearch} /></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div className="form-check form_checkboxes" id="myUL">
                                            {state ?
                                                optionsState.map((item, key) => {
                                                    return <label><span><input type="checkbox" value={item.value} name="programming" defaultChecked={formCode.includes(item.value)} onChange={(e) => handleChecked(e)} /> </span><span>{item.label}</span></label>
                                                }) :
                                                optionsState.map((item, key) => {
                                                    return <label><span><input type="checkbox" value={item.value} name="programming" /></span> <span>{item.label}</span></label>
                                                })
                                            }




                                        </div>
                                    </div>   
                            

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={ValidateRoleFormMapping}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={ValidateRoleFormMapping}>Save</button>}

                                        {/* <button className="btn btn-outline-primary" type="button" onClick={handleResetForm}>Reset</button> */}
                                        <button className="btn btn-outline-danger" type="button" onClick={() => navigate("/usermanagement/roleformmapping")}>Cancel</button>
                                    </div>


                                </div>
                            </form>
                        </div>
                    </div>




                </section>
            </main>
          
        </>
    )
}

export default AddNewRoleForm;